import firebaseApp from "../firebase/credenciales";
import { collection, doc, getFirestore, getDoc } from 'firebase/firestore';
const db = getFirestore(firebaseApp);

const getFirestoreRecordById = async (collectionName, documentId) => {
  try {

    const collectionRef = collection(db, collectionName);
    const docRef = doc(collectionRef, documentId);
    const docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      const record = docSnapshot.data();
      return record;
    } else {
      throw new Error('El registro no existe.');
    }
  } catch (error) {
    console.error('Error al obtener el registro:', error);
    throw error;
  }
};

export default getFirestoreRecordById
